import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PredictivePolicing.css';

const PredictivePolicing = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Helper: get ?file=mapX.html from URL
    const getInitialMapFromQuery = () => {
        const params = new URLSearchParams(location.search);
        return params.get('file') || 'All_Crimes.html';
    };

    const [activeMap, setActiveMap] = useState(getInitialMapFromQuery());
    const [activeTab, setActiveTab] = useState('info');

    const tabs = [
        { id: 'info', label: 'Info' },
        { id: 'statistics', label: 'Statistics' },
        { id: 'ai', label: 'AI' },
    ];

    const maps = [
        { name: 'All Crimes', file: 'All_Crimes.html' },
        { name: 'Heat Map', file: 'All_Crimes_Heat.html' },
        { name: 'Crimes against Persons', file: 'Person_Crimes.html' },
        { name: 'Crimes against Property', file: 'Property_Crimes.html' },
        { name: 'Misc Crimes', file: 'Misc_Crimes.html' },
    ];

    const statisticsMap = {
        'All_Crimes.html': `Total Crime Volume: 1500
Crime Rate per 10,000 people: 18
Crime Volume by Category:
AGGRAVATED ASSAULT: 50
SIMPLE ASSAULT: 50
INTIMIDATION: 50
MURDER AND NON-NEGLIGENT MANSLAUGHTER: 50
NEGLIGENT MANSLAUGHTER: 50
KIDNAPPING/ABDUCTION: 50
FORCIBLE RAPE: 50
FORCIBLE SODOMY: 50
SEXUAL ASSAULT WITH AN OBJECT: 50
FORCIBLE FONDLING: 50
ROBBERY: 50
HUMAN TRAFFICKING, COMMERCIAL SEX ACTS: 50
HUMAN TRAFFICKING, INVOLUNTARY SERVITUDE: 50
STATUTORY RAPE: 50
INCEST: 50
BURGLARY/BREAKING AND ENTERING: 50
LARCENY/THEFT: 50
MOTOR VEHICLE THEFT: 50
ARSON: 50
DESTRUCTION/DAMAGE/VANDALISM OF PROPERTY: 50
EMBEZZLEMENT: 50
EXTORTION/BLACKMAIL: 50
FRAUD - FALSE PRETENSES/SWINDLE/CONFIDENCE GAME: 50
FRAUD - CREDIT CARD/ATM FRAUD: 50
FRAUD - IMPERSONATION: 50
FRAUD - WIRE FRAUD: 50
STOLEN PROPERTY OFFENSES: 50
COUNTERFEITING/FORGERY: 50
BRIBERY: 50
POCKET-PICKING: 50

Crime Percentage by Category:
AGGRAVATED ASSAULT: 3.3%
SIMPLE ASSAULT: 3.3%
INTIMIDATION: 3.3%
MURDER AND NON-NEGLIGENT MANSLAUGHTER: 3.3%
NEGLIGENT MANSLAUGHTER: 3.3%
KIDNAPPING/ABDUCTION: 3.3%
FORCIBLE RAPE: 3.3%
FORCIBLE SODOMY: 3.3%
SEXUAL ASSAULT WITH AN OBJECT: 3.3%
FORCIBLE FONDLING: 3.3%
ROBBERY: 3.3%
HUMAN TRAFFICKING, COMMERCIAL SEX ACTS: 3.3%
HUMAN TRAFFICKING, INVOLUNTARY SERVITUDE: 3.3%
STATUTORY RAPE: 3.3%
INCEST: 3.3%
BURGLARY/BREAKING AND ENTERING: 3.3%
LARCENY/THEFT: 3.3%
MOTOR VEHICLE THEFT: 3.3%
ARSON: 3.3%
DESTRUCTION/DAMAGE/VANDALISM OF PROPERTY: 3.3%
EMBEZZLEMENT: 3.3%
EXTORTION/BLACKMAIL: 3.3%
FRAUD - FALSE PRETENSES/SWINDLE/CONFIDENCE GAME: 3.3%
FRAUD - CREDIT CARD/ATM FRAUD: 3.3%
FRAUD - IMPERSONATION: 3.3%
FRAUD - WIRE FRAUD: 3.3%
STOLEN PROPERTY OFFENSES: 3.3%
COUNTERFEITING/FORGERY: 3.3%
BRIBERY: 3.3%
POCKET-PICKING: 3.3%
      `,
        
        'Person_Crimes.html': 
        `Total Crime Volume: 750
Crime Rate per 10,000 people: 9

Crime Volume by Category:
AGGRAVATED ASSAULT: 50
SIMPLE ASSAULT: 50
INTIMIDATION: 50
MURDER AND NON-NEGLIGENT MANSLAUGHTER: 50
NEGLIGENT MANSLAUGHTER: 50
KIDNAPPING/ABDUCTION: 50
FORCIBLE RAPE: 50
FORCIBLE SODOMY: 50
SEXUAL ASSAULT WITH AN OBJECT: 50
FORCIBLE FONDLING: 50
ROBBERY: 50
HUMAN TRAFFICKING, COMMERCIAL SEX ACTS: 50
HUMAN TRAFFICKING, INVOLUNTARY SERVITUDE: 50
STATUTORY RAPE: 50
INCEST: 50

Crime Percentage by Category:
AGGRAVATED ASSAULT: 6.6%
SIMPLE ASSAULT: 6.6%
INTIMIDATION: 6.6%
MURDER AND NON-NEGLIGENT MANSLAUGHTER: 6.6%
NEGLIGENT MANSLAUGHTER: 6.6%
KIDNAPPING/ABDUCTION: 6.6%
FORCIBLE RAPE: 6.6%
FORCIBLE SODOMY: 6.6%
SEXUAL ASSAULT WITH AN OBJECT: 6.6%
FORCIBLE FONDLING: 6.6%
ROBBERY: 6.6%
HUMAN TRAFFICKING, COMMERCIAL SEX ACTS: 6.6%
HUMAN TRAFFICKING, INVOLUNTARY SERVITUDE: 6.6%
STATUTORY RAPE: 6.6%
INCEST: 6.6%`
        ,
      
        'Property_Crimes.html':
        `Total Crime Volume: 600
Crime Rate per 10,000 people: 7.2

Crime Volume by Category:
BURGLARY/BREAKING AND ENTERING: 50
LARCENY/THEFT: 50
MOTOR VEHICLE THEFT: 50
ARSON: 50
DESTRUCTION/DAMAGE/VANDALISM OF PROPERTY: 50
EMBEZZLEMENT: 50
EXTORTION/BLACKMAIL: 50
FRAUD - FALSE PRETENSES/SWINDLE/CONFIDENCE GAME: 50
FRAUD - CREDIT CARD/ATM FRAUD: 50
FRAUD - IMPERSONATION: 50
FRAUD - WIRE FRAUD: 50
STOLEN PROPERTY OFFENSES: 50
COUNTERFEITING/FORGERY: 50
BRIBERY: 50
POCKET-PICKING: 50

Crime Percentage by Category:
BURGLARY/BREAKING AND ENTERING: 6.6%
LARCENY/THEFT: 6.6%
MOTOR VEHICLE THEFT: 6.6%
ARSON: 6.6%
DESTRUCTION/DAMAGE/VANDALISM OF PROPERTY: 6.6%
EMBEZZLEMENT: 6.6%
EXTORTION/BLACKMAIL: 6.6%
FRAUD - FALSE PRETENSES/SWINDLE/CONFIDENCE GAME: 6.6%
FRAUD - CREDIT CARD/ATM FRAUD: 6.6%
FRAUD - IMPERSONATION: 6.6%
FRAUD - WIRE FRAUD: 6.6%
STOLEN PROPERTY OFFENSES: 6.6%
COUNTERFEITING/FORGERY: 6.6%
BRIBERY: 6.6%
POCKET-PICKING: 6.6%
        `,
      
        'Misc_Crimes.html':
        `Total Crime Volume: 150
Crime Rate per 10,000 people: 1.8

Crime Volume by Category:
ANIMAL CRUELTY: 10
DISORDERLY CONDUCT: 10
DOMESTIC VIOLENCE: 10
DRUG POSSESSION: 10
DRIVING UNDER THE INFLUENCE (DUI): 10
HOMICIDE (GENERAL): 10
TRESPASSING: 10
PROSTITUTION: 10
PUBLIC INTOXICATION: 10
OTHER (Unclassified or Minor Infractions): 50

Crime Percentage by Category:
ANIMAL CRUELTY: 6.6%
DISORDERLY CONDUCT: 6.6%
DOMESTIC VIOLENCE: 6.6%
DRUG POSSESSION: 6.6%
DRIVING UNDER THE INFLUENCE (DUI): 6.6%
HOMICIDE (GENERAL): 6.6%
TRESPASSING: 6.6%
PROSTITUTION: 6.6%
PUBLIC INTOXICATION: 6.6%
OTHER: 33.3%
        `,
      };

      const aiMap = {
        'All_Crimes.html': 
        `Top Days: Wednesday & Thursday (both 225), followed by Tuesday (217)
Top Districts: Northeast (321), Southeast (315), Central (306)
Peak Times: Evening to late night hours (19:00, 18:00, 14:00, etc.)
Top Categories:
    Aggravated Assault
    Simple Assault
    Bribery
    Counterfeiting/Forgery
    Stolen Property Offense

Pattern Insight: Unfortunately, without access to specific tools or datasets, 
it's challenging to identify patterns in the crime data. 
However, some general insights can be provided. Crime rates and patterns often correlate with socio-economic factors, 
such as poverty, unemployment, and lack of community resources. 
Additionally, certain times of day, locations, and circumstances (e.g., domestic disputes) 
may be more prone to criminal activity. If you have access to the actual crime data or a similar dataset, 
I can try to assist in identifying patterns using alternative methods.
`,
        
        'Person_Crimes.html': 
        `Top Days: Wednesday (125), Friday (116), Saturday & Sunday (108 each)
Top Districts: Northeast (164), Central (158), Southeast (150)
Peak Times: Spread across morning and evening (19:00, 06:00, 02:00)
Top Categories:
    Aggravated Assault
    Simple Assault
    Intimidation
    Murder and Non-Negligent Manslaughter
    Negligent Manslaughter

Pattern Insight: Unfortunately, I couldn't find any meaningful patterns in the Crime Data for Person Crimes 
as the tool doesn't provide enough information to draw conclusions.
`
        ,
      
        'Property_Crimes.html':
        `Top Days: Thursday (87), Tuesday (73), Friday (73)
Top Districts: Northeast (112), Southeast (111), Central (99)
Peak Times: Spread across early morning and night (07:00, 02:00, 01:00)
Top Categories:
    Burglary/Breaking and Entering
    Larceny/Theft
    Motor Vehicle Theft
    Arson
    Vandalism
    
Pattern Insight: Analyzing the Crime Data for Property Crimes, I found some patterns. 
However, without further information or context about the specific dataset and its limitations, it's challenging to provide a detailed analysis. 
If you could provide more details or clarify your request, I'd be happy to assist further.

`,
      
        'Misc_Crimes.html':
        `Top Days: Thursday (45), Monday (41), Saturday (38)
Top Districts: Southeast (54), Southwest (54), Central (49)
Peak Times: Early morning and late night (05:00, 10:00, 23:00)
Top Categories:
    Fraud/False Pretenses
    Credit Card/ATM Fraud
    Impersonation
    Wire Fraud
    Pocket-Picking

Pattern Insight: Unfortunately, without a clear understanding of what constitutes a "pattern" in the context of crime data, 
it's challenging to provide a meaningful analysis. 
However, I can suggest some general approaches that might be helpful in identifying trends or anomalies in crime data, 
such as analyzing time-series data, geographic distributions, or correlations between different types of crimes. 
Would you like me to elaborate on any of these?
`,
      };


    // Sync URL when map changes via dropdown
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('file') !== activeMap) {
            params.set('file', activeMap);
            navigate(`${location.pathname}?${params.toString()}`, { replace: true });
        }
    }, [activeMap, location.pathname, navigate]);

    return (
        <div className="predictive-layout">
            <div className="sidebar">
            <button onClick={() => navigate('/projects')}>← Back to Map Menu</button>

            <h2>Map Options</h2>

            <label>Select Map</label>
            <select
                value={activeMap}
                onChange={(e) => setActiveMap(e.target.value)}
            >
                {maps.map((map, index) => (
                <option key={index} value={map.file}>
                    {map.name}
                </option>
                ))}
            </select>

            {tabs.map((tab) => (
                <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
                >
                {tab.label}
                </button>
            ))}

            <div className="tab-content">
                {activeTab === 'info' && <p>This project is an interactive map program created for Polk County Sheriffs office. The goal was to create a program would display a marker map of the locations of crimes. Additionally, a Large Language Model performs an analysis on this data to find possible patterns and connections with how crimes are comitted and their location. The original project used reports from active investigations, and is not available to the public. So this demo used mock data, as reflected in the statistical analysis and the analysis performed by the AI overview.</p>}
                {activeTab === 'statistics' && <pre>{statisticsMap[activeMap]}</pre>}
                {activeTab === 'ai' && <pre>{aiMap[activeMap]}</pre>}
            </div>
            </div>

            <div className="map-container">
            <iframe
                key={activeMap}
                src={`/maps/${activeMap}`}
                title="Map Preview"
            />
            </div>
        </div>
        );
};

export default PredictivePolicing;